import {getDataWith1C} from "@/views/DataWith1C/api";

export const getDataWithOneC = async (params = {}) => {
  try {
    const res = await getDataWith1C(params);
    return res?.costs;
  } catch (e) {
    return null
  }
}